import * as React from "react";

import { Button } from "semantic-ui-react";
import axios, { isAxiosError } from "axios";

import { CaseType } from "@teamprevent/common/model";

import { CoreDetailProps } from "../Detail";

import { Link } from "redux-little-router";

export const CoreDetailsButtons: React.FunctionComponent<CoreDetailProps> = (props: CoreDetailProps) => {
    const [hasReferral, setHasReferral] = React.useState(null);
    const [loadingHasReferral, setLoadingHasReferral] = React.useState(null);
    React.useEffect(() => {
        if (loadingHasReferral === null) {
            setLoadingHasReferral(true);
            (async () => {
                try {
                    const response = await axios.head(`/api/case/matchedreferral/${props.ohCase.id}`);
                    if (response.status === 200) {
                        setHasReferral(true);
                    }
                } catch (e) {
                    if (isAxiosError(e) && e.response && e.response.status === 404) {
                        setHasReferral(false);
                    }
                }
                setLoadingHasReferral(false);
            })();
        }
    }, [loadingHasReferral, props.ohCase.id]);
    const getReferralLinks = () => {
        const links = [];

        if (hasReferral !== false)
        {
            links.push({ href: `${props.ohCase.id}/matchedReferral`, content: "View Referral", loading: loadingHasReferral });
        }

        if (props.ohCase.linkedOhCases) {
            const workAdjustments = props.ohCase.linkedOhCases.filter(ohCase => ohCase.caseType === CaseType.WORK_ADJUSTMENT);
            if (workAdjustments) {
                links.push(...workAdjustments.map(ohCase => {
                    return { href: `/workadjustments/${ohCase.id}`, content: `View Work Adjustment Case ${ohCase.caseId}` };
                }));
            }
        }
        return links;
    };

    const getPhysiotherapyReferralLinks = () => {
        return [{ href: `${props.ohCase.id}/matchedPhysiotherapyReferral`, content: "View Referral" }];
    };

    const getPpqLinks = () => {
        return [{ href: `${props.ohCase.id}/ppq`, content: "View PPQ" }];
    };

    const getGenericCaseLinks = () => {
        return [{ href: `${props.ohCase.id}/genericCaseForm`, content: "View Form" }];
    };

    const getWorkAdjustmentLinks = () => {
        return props.ohCase.linkedOhCases && props.ohCase.linkedOhCases?.filter(ohCase => ohCase.caseType === CaseType.REFERRAL)?.map(ohCase => {
            return {
                href: `/ohCases/${ohCase.id}`, content: `View Referral Case ${ohCase.caseId}`
            };
        });
    };

    const getDefault = () => {
        if (props.ohCase.genericCaseType)
        {
            return getGenericCaseLinks();
        }

        return [];
    };

    const getLinks = (): { href: string; content: string; loading?: boolean }[] => {
        switch (props.ohCase.caseType) {
            case CaseType.REFERRAL:
                return getReferralLinks();
            case CaseType.PHYSIOTHERAPY_REFERRAL:
                return getPhysiotherapyReferralLinks();
            case CaseType.PPQ:
                return getPpqLinks();
            case CaseType.WORK_ADJUSTMENT:
                return getWorkAdjustmentLinks();
            default:
                return getDefault();
        }
    };

    return (<>
        {getLinks()?.map(link => {
            return (
                <Button content={link.content} as={Link} href={link.href} key={link.href} loading={link.loading} />
            );
        })}
    </>);
};
